var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "展示名称", prop: "show_name" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "请输入展示名称(用于后台显示)"
                },
                model: {
                  value: _vm.form.show_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "show_name", $$v)
                  },
                  expression: "form.show_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "游戏标识", prop: "game_type" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入游戏标识" },
                model: {
                  value: _vm.form.game_type,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "game_type", $$v)
                  },
                  expression: "form.game_type"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "应用ID", prop: "appid" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入应用ID" },
                model: {
                  value: _vm.form.appid,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "appid", $$v)
                  },
                  expression: "form.appid"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "密钥KEY",
                prop: "appsecret",
                rules: _vm.form.appid ? _vm.rules.appsecret : []
              }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入密钥KEY" },
                model: {
                  value: _vm.form.appsecret,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "appsecret", $$v)
                  },
                  expression: "form.appsecret"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "语言", prop: "language" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    placeholder: "请选择"
                  },
                  on: { change: _vm.langContentChange },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.languageLists, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.sign }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "state" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%", "margin-bottom": "0" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addLoginContent()
                        }
                      }
                    },
                    [_vm._v("添加登录类型")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            _vm._l(_vm.form.login_type_list, function(domain, index) {
              return _c(
                "div",
                {
                  key: index + "k",
                  staticStyle: { width: "50%", display: "inline-block" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "lodingItem-operationFrame  x-c" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem",
                          staticStyle: { width: "100% !important" },
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: domain.value,
                              callback: function($$v) {
                                _vm.$set(domain, "value", $$v)
                              },
                              expression: "domain.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-button", {
                        staticStyle: { margin: "0 10px 24px 10px" },
                        attrs: {
                          size: "mini",
                          type: "danger",
                          circle: "",
                          icon: "el-icon-delete"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.removeLoginContent(domain)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%", "margin-bottom": "0" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addContent()
                        }
                      }
                    },
                    [_vm._v("添加参数")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.form.extend, function(domain, index) {
            return _c(
              "div",
              { key: index + "k", staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  { staticClass: "lodingItem-operationFrame  x-c" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        staticStyle: { "margin-right": "20px" },
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: domain.label,
                            callback: function($$v) {
                              _vm.$set(domain, "label", $$v)
                            },
                            expression: "domain.label"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: domain.value,
                            callback: function($$v) {
                              _vm.$set(domain, "value", $$v)
                            },
                            expression: "domain.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: { margin: "0 10px 24px 10px" },
                      attrs: {
                        size: "mini",
                        type: "danger",
                        circle: "",
                        icon: "el-icon-delete"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeContent(domain)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          _vm._l(_vm.form.params, function(item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", { staticClass: "langTitle" }, [
                  _vm._v(" " + _vm._s(item.languageName) + " ")
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "游戏名称",
                      prop: "params." + index + ".game_name",
                      rules: _vm.rules.game_name
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入游戏名称" },
                      model: {
                        value: item.game_name,
                        callback: function($$v) {
                          _vm.$set(item, "game_name", $$v)
                        },
                        expression: "item.game_name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "图标",
                      prop: "params." + index + ".icon",
                      rules: _vm.rules.icon
                    }
                  },
                  [
                    _c("uploadImage", {
                      attrs: { value: item.picfileList },
                      on: {
                        input: function($event) {
                          return _vm.imgChange($event, item, index)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }